import { STORE_CLOSEST_PARKING_INFO } from "./firstClosestParkingInfoReducer"

export const storeFirstClosestParkingInfo = (parkingTime, parkingCost) => ({
    type: STORE_CLOSEST_PARKING_INFO,
    payload: {
        parkingTime: parkingTime,
        parkingCost: parkingCost,
    }
})